// frontend/src/services/api.js
import axios from "axios";

// เรียก backend จาก origin เดียวกับที่หน้าเว็บถูกโหลดมาเสมอ (ไม่ว่าจะเข้าผ่าน www.
// หรือไม่มี www ก็ตาม) เพื่อให้เป็น same-origin request และไม่ต้องส่ง CORS
// preflight (OPTIONS) เลย เนื่องจาก server ปัจจุบันตอบ OPTIONS ด้วย 500 เสมอ
const isProdHost = /(^|\.)sskru\.ac\.th$/.test(window.location.hostname);
const API_URL = isProdHost
  ? `${window.location.origin}/backend`
  : "https://www.lifelong.sskru.ac.th/backend";

console.log("🚀 API URL:", API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log(`📤 Request with token to: ${config.url}`);
    } else {
      console.log(`📤 Request without token to: ${config.url}`);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`📥 Response: ${response.status} from ${response.config.url}`);
    return response;
  },
  (error) => {
    if (error.code === "ERR_NETWORK") {
      console.error(
        "❌ Network Error - Cannot connect to:",
        error.config?.baseURL,
      );
    } else if (error.response) {
      console.error(
        "❌ API Error:",
        error.response.status,
        error.response.data,
      );

      // ถ้าเป็น 401 Unauthorized ให้ logout
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    } else {
      console.error("❌ Error:", error.message);
    }

    return Promise.reject(error);
  },
);

export default api;
